function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}

(function($) {

  // Get Window Width and Height
  var windowWidth = $(window).outerWidth();
  var windowHeight = $(window).height();

  /* Document ready functions */
  $(document).ready(function (){

    // Apply style to a if touch device
    if (isTouchDevice()) {
      $('a, .puff-col').addClass('mobile');
      $('a, .puff-col').removeClass('desktop');
    }
    else {
      $('a, .puff-col').addClass('desktop');
      $('a, .puff-col').removeClass('mobile');
    }

    $('.mobile').on('touchstart touchend', function(e) {
        $(this).toggleClass('hover_effect');
    });

    // History back
    $( document ).on( 'click', '.back', function () {
      window.location=document.referrer;
    });

  });

  $(window).resize(function () {

    // Get Window Width and Height on resize
    windowWidth = $(window).outerWidth();
    windowHeight = $(window).height();


  });

})(jQuery);
